import * as React from 'react'
import MUILinearProgress from '@mui/material/LinearProgress'

// This component must have a parent that specifies height. Parents with auto height will not display this component.
const LinearProgress = (props) => <MUILinearProgress {...props} />

export default LinearProgress
